<template>
    <div class="card-challenge-result-item-incomplete">
        <div class="wr-card-challenge-result-item-incomplete__users">
            <div class="card-challenge-result-item-incomplete__user1">
                <div class="wr-card-challenge-result-item-incomplete__user">
                    <img :src="userImageLink1" class="card-challenge-result-item-incomplete__user-img">
                    <span class="card-challenge-result-item-incomplete__username">{{ username1 }}</span>
                    <div
                        class="card-challenge-result-item-incomplete__user-status"
                        :class="userStatusClass1">
                        <span class="card-challenge-result-item-incomplete__user-status-icon"></span>
                        <span class="card-challenge-result-item-incomplete__user-status-text">{{ userStatus1 }}</span>
                    </div>
                </div>
            </div>
            <div class="card-challenge-result-item-incomplete__user2">
                <div class="wr-card-challenge-result-item-incomplete__user">
                    <img :src="userImageLink2" class="card-challenge-result-item-incomplete__user-img">
                    <span class="card-challenge-result-item-incomplete__username">{{ username2 }}</span>
                    <div
                        class="card-challenge-result-item-incomplete__user-status"
                        :class="userStatusClass2">
                        <span class="card-challenge-result-item-incomplete__user-status-icon"></span>
                        <span class="card-challenge-result-item-incomplete__user-status-text">{{ userStatus2 }}</span>
                    </div>
                </div>
            </div>
            <div class="card-challenge-result-item-incomplete__separator">
                <span class="card-challenge-result-item-incomplete__separator-icon"></span>
                <span class="card-challenge-result-item-incomplete__separator-text">VS</span>
            </div>
        </div>
        <div class="card-challenge-result-item-incomplete__status">
            <span class="card-challenge-result-item-incomplete__status-text">{{ challengeStatus }}</span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            resultItem: {
                type: Object,
                default: {
                    id: 8,
                    status: "ONGOING",
                    user1: {
                        id: 1,
                        username: "temren",
                        status: "DONE-PRACTICE"
                    },
                    user2: {
                        id: 3,
                        username: "kral1790",
                        status: "WAIT-PRACTICE"
                    }
                }
            },
        },

        computed: {
            userStatusClass1(){
                if(this.resultItem.user2.status === 'REJECTED'){
                    return 'card-challenge-result-item-incomplete--cancelled';
                }
                return `card-challenge-result-item-incomplete--${this.resultItem.user1.status.toLowerCase()}`;
            },

            userStatusClass2(){
                return `card-challenge-result-item-incomplete--${this.resultItem.user2.status.toLowerCase()}`;
            },

            userImageLink1(){
                // return this.$store.state.api.img + this.resultItem.user1.id + '.jpg';
                return this.$store.state.api.getImage + this.resultItem.user1.id;
            },

            userImageLink2(){
                // return this.$store.state.api.img + this.resultItem.user2.id + '.jpg';
                return this.$store.state.api.getImage + this.resultItem.user2.id;
            },

            username1(){
                let curUserType = this.$store.state.challengeSession.userType;
                return curUserType === 1
                       ? 'sen'
                       : this.resultItem.user1.username;
            },

            username2(){
                let curUserType = this.$store.state.challengeSession.userType;
                return curUserType === 2
                       ? 'sen'
                       : this.resultItem.user2.username;
            },

            userStatus1(){
                let curUserType = this.$store.state.challengeSession.userType;
                if(this.resultItem.user2.status === 'REJECTED'){
                    return this.$t('challenge.status.cancelled');
                }
                if(this.resultItem.user1.status === 'DONE-PRACTICE'){
                    return curUserType === 1
                           ? this.$t('challenge.status.done-practice') + 'N'
                           : this.$t('challenge.status.done-practice');
                }
                return this.$t(`challenge.status.${this.resultItem.user1.status.toLowerCase()}`);
            },

            userStatus2(){
                let curUserType = this.$store.state.challengeSession.userType;
                if(this.resultItem.user2.status === 'DONE-PRACTICE'){
                    return curUserType === 2
                           ? this.$t('challenge.status.done-practice') + 'N'
                           : this.$t('challenge.status.done-practice');
                }
                return this.$t(`challenge.status.${this.resultItem.user2.status.toLowerCase()}`);
            },

            challengeStatus(){
                if(this.resultItem.status === 'ONGOING'){
                    return 'DEVAM EDİYOR';
                }
                else if(this.resultItem.status === 'CANCELLED'){
                    return 'İPTAL EDİLDİ';
                }
                return '';
            }
        }
    };
</script>

<style scoped src="@/css/components/card-challenge-result-item-incomplete.css"></style>